import { z } from "zod";
const numberOnlyError = "Value must be numeric";
const integerOnlyError = "Value must be an integer";
const excelColumnRegex = /^[A-Za-z]+$/;
const defaultFirstRowNumber = 1;
const defaultLastRowNumber = 20000;
const stringField = (maxLength) => z
    .string()
    .min(1, "This field is required")
    .max(maxLength ?? Infinity, `Exceeds maximum of ${maxLength} characters`);
const excelColumnField = z
    .string()
    .min(1, "This field is required")
    .regex(excelColumnRegex, "Only alphabetic characters allowed")
    .refine((col) => {
    // Normalize to uppercase for easier calculation
    const colUpper = col.toUpperCase();
    // Current Excel limit is 16,384 columns
    const colNum = colUpper
        .split("")
        .reduce((acc, char) => acc * 26 + (char.charCodeAt(0) - 64), 0);
    return colNum >= 1 && colNum <= 16384;
}, "Column out of range. Valid Range: A -> XFD");
export const formSchema = z.object({
    model_sheet: stringField(),
    line_items_column: excelColumnField,
    target_year: z.coerce.number().int({ error: () => integerOnlyError }),
    comparison_year: z.coerce.number().int({ error: () => integerOnlyError }),
    target_quarter: z.coerce.number().int({ error: () => integerOnlyError }),
    comparison_quarter: z.coerce.number().int({ error: () => integerOnlyError }),
    target_column: excelColumnField,
    comparison_column: excelColumnField,
    llm_model: stringField(),
    hot_topics: z.string().optional(),
    first_row_number: z.preprocess((val) => (val === "" || val === null ? undefined : val), z.coerce
        .number({ error: () => numberOnlyError })
        .int({ error: () => integerOnlyError })
        .default(defaultFirstRowNumber)),
    last_row_number: z.preprocess((val) => (val === "" || val === null ? undefined : val), z.coerce
        .number({ error: () => numberOnlyError })
        .int({ error: () => integerOnlyError })
        .default(defaultLastRowNumber)),
    return_summary: z.boolean({ error: () => "Return summary not checked!" }),
    overwrite_target: z.boolean({ error: () => "Overwrite target not checked!" }),
    source_urls: z
        .array(z.url("Must be a valid URL"))
        .min(1, "At least one URL is required"),
    ticker: stringField(),
});
export var UserMessageLevels;
(function (UserMessageLevels) {
    UserMessageLevels["success"] = "success";
    UserMessageLevels["warning"] = "warning";
    UserMessageLevels["error"] = "error";
})(UserMessageLevels || (UserMessageLevels = {}));
